import script from "./donationSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./donationSuccess.vue?vue&type=script&setup=true&lang=js"

import "./donationSuccess.vue?vue&type=style&index=0&id=274c527f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274c527f"]])

export default __exports__